import { useState } from "react";
import { Info, X } from "lucide-react";
import clsx from "clsx";

interface InfoTooltipProps {
  text: string;
  className?: string;
}

export default function InfoTooltip({ text, className }: InfoTooltipProps) {
  const [open, setOpen] = useState(false);

  return (
    <span className={clsx("relative inline-flex", className)}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="text-neko-gray hover:text-neko-orange transition-colors"
        aria-label="Info"
      >
        <Info className="w-3.5 h-3.5" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-56 bg-neko-dark border border-neko-dark-3 rounded-lg p-3 shadow-xl">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="absolute top-1.5 right-1.5 text-neko-gray hover:text-neko-white"
            >
              <X className="w-3 h-3" />
            </button>
            <p className="text-xs text-neko-gray-light leading-relaxed pr-3">{text}</p>
            <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-neko-dark-3" />
          </div>
        </>
      )}
    </span>
  );
}
